var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'label',
    ("label--" + (_vm.label || _vm.labelClass)),
    { 'label--tilted': _vm.tilted } ]},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }